import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = loc.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await api.post("/auth/google/exchange", { session_id });
        localStorage.setItem("piplight_token", r.data.token);
        const role = r.data.user.role;
        const target = role === "super_admin" ? "/super" : role === "admin" ? "/admin" : "/portal";
        toast.success(`Welcome, ${r.data.user.name}.`);
        // Force full navigation so AuthContext re-runs /me
        window.location.replace(target);
      } catch (e) {
        toast.error(formatErr(e));
        nav("/login");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground">
      Completing Google sign-in…
    </div>
  );
}
